import { NavTemplate, NotFoundArea } from 'components';

export function NotFound() {
  return (
    <NavTemplate>
      <NotFoundArea />
    </NavTemplate>
  );
}
